var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"sidebar"},[_c('sidebar')],1),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('layout-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }